export const currencies: App.SelectOptions[] = [
  { value: "", label: "Selecione" },
  { value: "BRL", label: "Real (BRL)" }
  // { value: "USD", label: "Dollar (USD)" },
  // { value: "EUR", label: "Euro (EUR)" }
]

export const currencyLocaleMap: { [key: string]: string } = {
  USD: "en-US",
  BRL: "pt-BR",
  EUR: "en-US"
}
